{
  "_generated": "GENERATED from clubezy-firebase-1225/functions/src/bundles.ts by `npm run routing:export`. Do not edit by hand.",
  "routes": {
    "admin_functions-auditMembershipIntegrity": "api-staff",
    "admin_functions-auditProfileIntegrity": "api-staff",
    "admin_functions-bulkAddMembers": "api-staff",
    "admin_functions-deactivateUserAccount": "api-staff",
    "admin_functions-endImpersonation": "api-staff",
    "admin_functions-endStaffSession": "api-staff",
    "admin_functions-getOrganisationSupportSnapshot": "api-staff",
    "admin_functions-getSeasonSupportSnapshot": "api-staff",
    "admin_functions-getSupportAuditLogs": "api-staff",
    "admin_functions-getUserSupportSnapshot": "api-staff",
    "admin_functions-grantGlobalAdmin": "api-staff",
    "admin_functions-grantOversight": "api-staff",
    "admin_functions-impersonateUser": "api-staff",
    "admin_functions-linkProfileToAuthAccount": "api-staff",
    "admin_functions-listChatsForSupport": "api-staff",
    "admin_functions-listChatSystemMessagesForSupport": "api-staff",
    "admin_functions-listOnboardingOrganisations": "api-staff",
    "admin_functions-listOrganisations": "api-staff",
    "admin_functions-listPendingAccountDeletions": "api-staff",
    "admin_functions-listSeasonsGlobal": "api-staff",
    "admin_functions-listStaffAccounts": "api-staff",
    "admin_functions-mergeAccounts": "api-staff",
    "admin_functions-onboardOrganisation": "api-staff",
    "admin_functions-purgeUserAccount": "api-staff",
    "admin_functions-reconcileAuthProfileBridge": "api-long",
    "admin_functions-repairFamilyLink": "api-staff",
    "admin_functions-repairMembershipFinding": "api-staff",
    "admin_functions-restoreUserAccount": "api-staff",
    "admin_functions-revokeGlobalAdmin": "api-staff",
    "admin_functions-revokeOversight": "api-staff",
    "admin_functions-searchUsersForSupport": "api-staff",
    "admin_functions-setUserEmailVerified": "api-staff",
    "admin_functions-startStaffSession": "api-staff",
    "announcements-addComment": "api-comms",
    "announcements-createAnnouncement": "api-comms",
    "announcements-deleteAnnouncement": "api-comms",
    "announcements-getAnnouncements": "api-core",
    "announcements-markAnnouncementSeen": "api-comms",
    "announcements-updateAnnouncement": "api-comms",
    "assessments-createAssessment": "api-events",
    "assessments-createAssessmentTemplate": "admin-season",
    "assessments-deleteAssessment": "api-events",
    "assessments-deleteAssessmentTemplate": "admin-season",
    "assessments-duplicateAssessmentTemplate": "admin-season",
    "assessments-getAssessmentsForEvent": "api-events",
    "assessments-getAssessmentsForMember": "api-events",
    "assessments-getAssessmentTemplates": "api-events",
    "assessments-updateAssessment": "api-events",
    "assessments-updateAssessmentTemplate": "admin-season",
    "auth-clearLegacyPasswordFlag": "api-profile",
    "auth-completeEmailChange": "api-public",
    "auth-createUser": "api-public",
    "auth-deleteAccount": "api-profile",
    "auth-getMigrationLoginHint": "api-public",
    "auth-requestEmailChange": "api-profile",
    "auth-resetPassword": "api-public",
    "auth-syncAuthProviderMetadata": "api-core",
    "auth-syncProfileClaim": "api-profile",
    "auth-verifyEmail": "api-public",
    "businessDirectory-createBusiness": "api-club",
    "businessDirectory-deleteBusiness": "api-club",
    "businessDirectory-getBusiness": "api-club",
    "businessDirectory-getBusinesses": "api-club",
    "businessDirectory-getBusinessTags": "api-club",
    "businessDirectory-manageTags": "api-club",
    "businessDirectory-updateBusiness": "api-club",
    "chats-addMembers": "api-comms",
    "chats-archiveChat": "api-comms",
    "chats-closeChat": "api-comms",
    "chats-createChat": "api-comms",
    "chats-createImageSlot": "api-comms",
    "chats-downloadTranscript": "api-comms",
    "chats-editMessage": "api-comms",
    "chats-getChatDetails": "api-core",
    "chats-getChats": "api-core",
    "chats-getMessages": "api-core",
    "chats-leaveChat": "api-comms",
    "chats-markRead": "api-core",
    "chats-removeMember": "api-comms",
    "chats-sendMessage": "api-comms",
    "chats-toggleNotifications": "api-comms",
    "chats-unsendMessage": "api-comms",
    "chats-updateMemberRole": "api-comms",
    "chats-warmup": "api-comms",
    "documents-createFolder": "api-comms",
    "documents-createUploadSlot": "api-comms",
    "documents-deleteDocument": "api-comms",
    "documents-deleteFolder": "api-comms",
    "documents-get": "api-comms",
    "documents-getViews": "api-comms",
    "documents-list": "api-comms",
    "documents-recordView": "api-comms",
    "documents-updateDocument": "api-comms",
    "documents-updateFolder": "api-comms",
    "events-addMembers": "api-events",
    "events-bulkUpdateAttendance": "api-events",
    "events-cancelEvent": "api-events",
    "events-createEvent": "api-events",
    "events-createRepeatingEvents": "api-events",
    "events-createRepeatingSeasonMemberEvents": "api-events",
    "events-createSeasonMemberEvent": "api-events",
    "events-deleteEvent": "api-events",
    "events-deleteRepeatingEvents": "api-events",
    "events-getEvent": "api-core",
    "events-getEventAttendees": "api-core",
    "events-getEvents": "api-core",
    "events-getTeamAttendanceReport": "admin-season",
    "events-lockAttendance": "api-events",
    "events-markAttendance": "api-events",
    "events-reinstateEvent": "api-events",
    "events-removeMember": "api-events",
    "events-rescheduleEvent": "api-events",
    "events-suggestEventTimeZone": "api-events",
    "events-updateAttendance": "api-events",
    "events-updateEvent": "api-events",
    "events-updateMemberPermission": "api-events",
    "events-updateRepeatingEvents": "api-events",
    "files-createImageSlot": "api-comms",
    "files-resolve": "api-comms",
    "fixtureImport-fetchFixtures": "admin-org",
    "fixtureImport-getImportStatus": "admin-org",
    "fixtureImport-getProviderSeasons": "admin-org",
    "fixtureImport-importFixtures": "admin-org",
    "fixtureImport-searchProvider": "admin-org",
    "fixtureImport-syncFixtures": "admin-org",
    "gear-createCartOrder": "api-club",
    "gear-createGear": "api-club",
    "gear-createOrder": "api-club",
    "gear-deleteGear": "api-club",
    "gear-getGear": "api-core",
    "gear-getOrderBuyer": "api-club",
    "gear-getOrders": "api-club",
    "gear-getUserOrders": "api-club",
    "gear-togglePurchaseable": "api-club",
    "gear-updateGear": "api-club",
    "gear-updateOrderStatus": "api-club",
    "groups-addChildGroup": "admin-season",
    "groups-addMembers": "api-membership",
    "groups-addTrialPlayers": "api-membership",
    "groups-createGroup": "api-membership",
    "groups-deleteGroup": "api-membership",
    "groups-getGroup": "api-core",
    "groups-getTrialPlayers": "api-core",
    "groups-promoteTrialPlayer": "api-membership",
    "groups-removeChildGroup": "admin-season",
    "groups-removeMember": "api-membership",
    "groups-removeTrialPlayers": "api-membership",
    "groups-setGroupMemberKind": "api-membership",
    "groups-setTrialWindow": "api-membership",
    "groups-toggleLock": "admin-season",
    "groups-updateGroup": "api-membership",
    "groups-updateMemberPermission": "api-membership",
    "kits-acknowledgeKitItems": "api-club",
    "kits-activateKit": "admin-org",
    "kits-archiveKit": "admin-org",
    "kits-bulkMarkFulfilled": "admin-org",
    "kits-createKit": "admin-org",
    "kits-deleteKit": "admin-org",
    "kits-duplicateKit": "admin-org",
    "kits-exportOrders": "admin-org",
    "kits-getKitAllocations": "admin-org",
    "kits-getKits": "admin-org",
    "kits-getMyKitAllocations": "api-club",
    "kits-markFulfilled": "admin-org",
    "kits-markItemsCollected": "admin-org",
    "kits-submitSizes": "api-club",
    "kits-updateKit": "admin-org",
    "matchObservations-deleteObservation": "api-events",
    "matchObservations-getObservationsForEvent": "api-events",
    "matchObservations-submitObservation": "api-events",
    "matchReports-approveMatchReport": "api-events",
    "matchReports-createMatchReport": "api-events",
    "matchReports-deleteMatchReport": "api-events",
    "matchReports-finalizeMatchReport": "api-events",
    "matchReports-getMatchEventsForSeason": "api-events",
    "matchReports-getMatchReport": "api-events",
    "matchReports-getMatchReports": "api-events",
    "matchReports-rejectMatchReport": "api-events",
    "matchReports-reopenMatchReport": "api-events",
    "matchReports-unapproveMatchReport": "api-events",
    "matchReports-updateMatchReport": "api-events",
    "organisations-acceptAgreement": "api-club",
    "organisations-addAccreditationType": "admin-org",
    "organisations-addBankAccount": "admin-org",
    "organisations-addEventType": "api-club",
    "organisations-addLink": "admin-org",
    "organisations-addPolicy": "admin-org",
    "organisations-addPosition": "admin-org",
    "organisations-archiveOrganisation": "admin-org",
    "organisations-createAgreement": "admin-org",
    "organisations-createAgreementAttachmentSlot": "admin-org",
    "organisations-createOrganisation": "api-club",
    "organisations-deleteOrganisation": "api-club",
    "organisations-getAccreditationDocumentUrl": "admin-org",
    "organisations-getActiveAgreements": "api-club",
    "organisations-getAgreementAcceptances": "admin-org",
    "organisations-getMemberAccreditations": "admin-org",
    "organisations-getPendingAgreements": "api-core",
    "organisations-removeAccreditationType": "admin-org",
    "organisations-removeBankAccount": "admin-org",
    "organisations-removeEventType": "api-club",
    "organisations-removeLink": "admin-org",
    "organisations-removePolicy": "admin-org",
    "organisations-removePosition": "admin-org",
    "organisations-restoreOrganisation": "admin-org",
    "organisations-reviewAccreditation": "admin-org",
    "organisations-setAgreementStatus": "admin-org",
    "organisations-setDefaultBankAccount": "admin-org",
    "organisations-suggestOrganisationTimeZone": "api-club",
    "organisations-updateAccreditationType": "admin-org",
    "organisations-updateAgreement": "admin-org",
    "organisations-updateBankAccount": "admin-org",
    "organisations-updateContact": "admin-org",
    "organisations-updateEventType": "admin-org",
    "organisations-updateImage": "admin-org",
    "organisations-updateOrganisation": "api-club",
    "organisations-updatePosition": "admin-org",
    "places-autocomplete": "api-club",
    "places-getPlaceDetails": "api-club",
    "polls-closePoll": "api-comms",
    "polls-createPoll": "api-comms",
    "polls-getMyVotes": "api-comms",
    "polls-getVoters": "api-comms",
    "polls-listSeason": "admin-season",
    "polls-vote": "api-comms",
    "rbac-getMyAccess": "api-core",
    "registrations-approveRegistration": "api-membership",
    "registrations-checkInTrialRegistration": "api-membership",
    "registrations-createRegistration": "api-public",
    "registrations-createRegistrationForm": "admin-season",
    "registrations-createTrialPhotoSlot": "api-membership",
    "registrations-declineRegistration": "api-membership",
    "registrations-deleteRegistration": "api-membership",
    "registrations-deleteRegistrationForm": "admin-season",
    "registrations-duplicateRegistrationForm": "admin-season",
    "registrations-getDocumentUrl": "api-membership",
    "registrations-getMyPendingRegistrations": "api-core",
    "registrations-getPublicRegistrationContext": "api-public",
    "registrations-getRegistrations": "api-core",
    "registrations-getRegistrationsByForm": "admin-season",
    "registrations-inviteRegistration": "api-membership",
    "registrations-inviteSelectedTrialists": "admin-season",
    "registrations-saveRegistrationImageMetadata": "admin-season",
    "registrations-setRegistrationFormStatus": "admin-season",
    "registrations-submitRegistration": "api-membership",
    "registrations-updateRegistration": "api-membership",
    "registrations-updateRegistrationForm": "admin-season",
    "reports-generateReport": "api-long",
    "seasons-acceptInvite": "api-membership",
    "seasons-addMemberManually": "api-membership",
    "seasons-addMembers": "api-membership",
    "seasons-archiveSeason": "admin-season",
    "seasons-createAccountFromInvite": "api-public",
    "seasons-createSeason": "api-membership",
    "seasons-createSeasonFromTemplate": "api-membership",
    "seasons-declineInvite": "api-membership",
    "seasons-deleteSeason": "admin-season",
    "seasons-getGroupsForSeason": "api-core",
    "seasons-getInviteLink": "api-membership",
    "seasons-getInvitePreview": "api-public",
    "seasons-getMemberComplianceReport": "admin-season",
    "seasons-getMemberProfiles": "admin-season",
    "seasons-getMembers": "api-core",
    "seasons-getMyOrganisations": "api-core",
    "seasons-getMyPendingInvites": "api-core",
    "seasons-getSeasonInvites": "admin-season",
    "seasons-getSeasonsUsingForm": "admin-season",
    "seasons-inviteByEmail": "api-membership",
    "seasons-inviteParentToChild": "api-membership",
    "seasons-removeMember": "api-membership",
    "seasons-retainMembers": "admin-season",
    "seasons-revokeInvite": "admin-season",
    "seasons-setActive": "api-membership",
    "seasons-setMemberChecklistItem": "admin-season",
    "seasons-setMemberPaymentStatus": "admin-season",
    "seasons-setMemberStatus": "admin-season",
    "seasons-setSeasonRegistrationForms": "admin-season",
    "seasons-toggleRegistrations": "admin-season",
    "seasons-toggleTrials": "admin-season",
    "seasons-updateMemberEmergencyContacts": "admin-season",
    "seasons-updateMemberRoles": "api-membership",
    "seasons-updateSeason": "api-membership",
    "sponsors-createSponsor": "api-club",
    "sponsors-deleteSponsor": "api-club",
    "sponsors-getGroupSponsors": "api-core",
    "sponsors-getSponsor": "api-club",
    "sponsors-getSponsors": "api-club",
    "sponsors-linkSponsorsToGroup": "api-club",
    "sponsors-updateSponsor": "api-club",
    "trials-changeTrialTeam": "api-events",
    "trials-getTrialResults": "api-events",
    "trials-setSelectionOutcome": "api-events",
    "users-addAccreditation": "api-profile",
    "users-addChildAccount": "api-profile",
    "users-addEmergencyContact": "api-profile",
    "users-clearDevice": "api-profile",
    "users-createAccreditationUploadSlot": "api-profile",
    "users-createAvatarSlot": "api-profile",
    "users-createProfile": "api-profile",
    "users-getMemberProfile": "api-core",
    "users-removeAccreditation": "api-profile",
    "users-removeAvatar": "api-profile",
    "users-removeChildAccount": "api-profile",
    "users-removeEmergencyContact": "api-profile",
    "users-removeParentLink": "api-profile",
    "users-setAvatar": "api-profile",
    "users-submitAccreditation": "api-profile",
    "users-toggleNotifications": "api-profile",
    "users-updateChildProfile": "api-profile",
    "users-updateDevice": "api-core",
    "users-updateEmergencyContact": "api-profile",
    "users-updateImage": "api-profile",
    "users-updateProfile": "api-profile"
  }
}
